class ProductShippingOptions extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.triggers = [...this.querySelectorAll('[data-delivery-trigger]')];
    this.renderDeliveryDates();

    this.handleTriggerClick = this.handleTriggerClick.bind(this);
    this.handleTriggerKeydown = this.handleTriggerKeydown.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);

    for (const trigger of this.triggers) {
      trigger.addEventListener('click', this.handleTriggerClick);
      trigger.addEventListener('keydown', this.handleTriggerKeydown);
    }
    document.addEventListener('click', this.handleDocumentClick);
  }

  disconnectedCallback() {
    for (const trigger of this.triggers || []) {
      trigger.removeEventListener('click', this.handleTriggerClick);
      trigger.removeEventListener('keydown', this.handleTriggerKeydown);
    }
    document.removeEventListener('click', this.handleDocumentClick);
  }

  renderDeliveryDates() {
    for (const dateRange of this.querySelectorAll('[data-delivery-range]')) {
      const minBusinessDays = Number.parseInt(dateRange.dataset.minBusinessDays || '0', 10);
      const maxBusinessDays = Number.parseInt(dateRange.dataset.maxBusinessDays || '0', 10);
      if (!Number.isFinite(minBusinessDays) || !Number.isFinite(maxBusinessDays)) continue;

      const startDate = this.addBusinessDays(new Date(), minBusinessDays);
      const endDate = this.addBusinessDays(new Date(), maxBusinessDays);
      dateRange.textContent = this.formatDateRange(startDate, endDate);
      dateRange.setAttribute('aria-label', `${this.formatFullDate(startDate)} to ${this.formatFullDate(endDate)}`);
    }
  }

  addBusinessDays(startDate, daysToAdd) {
    const date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 12);
    let remainingDays = daysToAdd;

    while (remainingDays > 0) {
      date.setDate(date.getDate() + 1);
      const dayOfWeek = date.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) remainingDays -= 1;
    }

    return date;
  }

  formatDateRange(startDate, endDate) {
    const start = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' }).format(startDate);
    const endOptions = startDate.getMonth() === endDate.getMonth() && startDate.getFullYear() === endDate.getFullYear()
      ? { day: 'numeric' }
      : { month: 'short', day: 'numeric' };
    const end = new Intl.DateTimeFormat('en-US', endOptions).format(endDate);
    return `${start}–${end}`;
  }

  formatFullDate(date) {
    return new Intl.DateTimeFormat('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    }).format(date);
  }

  handleTriggerClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.toggleTrigger(event.currentTarget);
  }

  handleTriggerKeydown(event) {
    if (event.key !== 'Escape') return;
    this.closeAll();
    event.currentTarget.blur();
  }

  handleDocumentClick(event) {
    if (!this.contains(event.target)) this.closeAll();
  }

  toggleTrigger(trigger) {
    const details = trigger.closest('.product-delivery-returns__details');
    const shouldOpen = !details?.classList.contains('is-open');
    this.closeAll();

    if (shouldOpen && details) {
      details.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }
  }

  closeAll() {
    for (const trigger of this.triggers) {
      trigger.closest('.product-delivery-returns__details')?.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }
  }
}

if (!customElements.get('product-shipping-options')) {
  customElements.define('product-shipping-options', ProductShippingOptions);
}
